export const PLACEHOLDER_AVATAR = "https://via.placeholder.com/160?text=Avatar"
export const TABS = ["Perfil", "Minhas turmas"]
